import React, { FC } from 'react';

import { Modal } from 'Src/feature/modal/Modal';

import { TaxExemptModalContent } from './TaxExemptModalContent';

const TEST_ID = {
  root: 'TaxExemptModal-test',
} as const;

interface TaxExemptModalProps {
  checkId: number | undefined;
  open: boolean;
  onClose: () => void;
}

const TaxExemptModal: FC<TaxExemptModalProps> = (props) => (
  <Modal
    data-testid={TEST_ID.root}
    open={props.open}
    onBackDropClick={props.onClose}
  >
    <TaxExemptModalContent {...props} />
  </Modal>
);

export { TaxExemptModal, TEST_ID };
export type { TaxExemptModalProps };
